import { font } from '@chegg-ui/theme'
import { smallLayout, themeBreakPoints } from '@chegg-wt/core/theme/theme'
import styled, { css } from 'styled-components'
import { MainWrapper } from '../styled'

const primaryThemeColor = css`
  ${({ theme }) => theme.Colors.primaryColor}
`

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor20};
  display: flex;
  flex-direction: column;
  align-items: center;
`
export const WritingFormsWrapper = styled.div`
  position: relative;
  min-height: 580px;
  max-width: 836px;
  background-color: white;
  margin: 16px;
  padding-bottom: 120px;

  @media (min-width: ${({ theme }) => smallLayout(theme)}) {
    margin: 16px 32px;
  }
  @media (min-width: ${({ theme }) => themeBreakPoints.small(theme)}) {
    min-width: 700px;
  }

  .wt-writing-forms-container {
    background-color: white;
    padding-top: 2%;

    input[type='checkbox']:checked + svg,
    input[type='checkbox']:checked:hover + svg {
      > g > rect {
        fill: ${primaryThemeColor};
        stroke: ${primaryThemeColor};
      }
    }
    input[type='checkbox']:not(:disabled):hover + svg {
      > g > rect {
        stroke: ${primaryThemeColor};
      }
    }
  }
  .wt-writing-forms-container > h3:first-of-type {
    display: none;
  }
  h3 {
    display: flex;
  }
  .wf-contributors {
    @media (min-width: ${({ theme }) => themeBreakPoints.extraSmall(theme)}) {
      flex-wrap: nowrap;
    }
    .first,
    .middle,
    .last {
      flex: 1 1 75%;
    }
  }

  .wf-recommendation-bar-box {
    margin-top: 2%;
  }
  .form-package-wrapper {
    display: none;
  }
  .wf-add-link-button {
    display: flex;
  }
  a:active,
  a:hover {
    text-decoration: none;
  }

  /* overriding colors for site specific theme */
  input[type='text'],
  textarea {
    &:focus,
    &:active {
      border-color: ${primaryThemeColor};
      box-shadow: none;
    }
  }

  input[type='radio']:checked + svg,
  input[type='radio']:checked:hover + svg {
    // radio button icon
    > g > circle:first-of-type {
      //outer circle
      stroke: ${primaryThemeColor};
    }
    > g > circle:nth-of-type(2) {
      //inner circle
      fill: ${primaryThemeColor};
    }
  }

  button[data-test='create-citation-button-form'],
  button[data-test='update-citation-button-form'] {
    border-color: ${primaryThemeColor};
    background: ${primaryThemeColor};

    &:active,
    &:hover {
      border-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
      background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor23};
    }
  }

  li[role='presentation'] > a[role='tab']::after {
    //tab border
    background-color: ${primaryThemeColor};
  }

  div[role='group'] {
    & > h3 {
      // group headings
      font-weight: ${font.weight.bold};
    }
  }
`

export const FormMainWrapper = styled(MainWrapper)`
  max-width: 900px;

  @media (min-width: 900px) {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
  }
`
